import { useEffect, useState } from 'react';
import Gateway from '../Gateway';
import { useSelector, useDispatch } from 'react-redux';
import EditAutomationSystemModal from './EditAutomationSystemModal';
import AutomationSystemCard from './AutomationSystemCard';
import AutomationSystemConfigurationCard from './AutomationSystemConfigurationCard';
import { loadMachineAutomationSystem, loadMachineAutomationSystemConfig } from '../../../../redux/machines/actions';
import { getAutomationSystem, getAutomationSystemConfig } from 'redux/machines/selectors';
import AutomationSystemCardLoader from './AutomationSystemCardLoader';
import AutomationSystemConfigurationLoader from './AutomationSystemConfigurationLoader';
import { PlcType } from 'attrs/plcConfigValues';
import EditAutomationSystemConfigurationIRISV3 from './EditAutomationSystemConfigurationIRISV3';
import EditAutomationSystemConfigurationIRISV2Rockwell from './EditAutomationSystemConfigurationIRISV2Rockwell';
import EditAutomationSystemConfigurationIRISV2Siemens from './EditAutomationSystemConfigurationIRISV2Siemens';
import EditAutomationSystemConfigurationIRISV3Essentials from './EditAutomationSystemConfigurationIRISV3Essentials';
import EditAutomationSystemConfigurationIRISV3Inside from './EditAutomationSystemConfigurationIRISV3Inside';
import EditAutomationSystemConfigurationIRISV3InsideRockwell
  from './EditAutomationSystemConfigurationIRISV3InsideRockwell';

interface AutomationSystemProps {
  machineId: string;
}

const AutomationSystem = ({ machineId }: AutomationSystemProps) => {
  const dispatch = useDispatch();

  const [displayEditAutomationSystemModal, setDisplayEditAutomationSystemModal] = useState(false);
  const handleCloseAutomationSystemModal = () => setDisplayEditAutomationSystemModal(false);

  const [displayEditAutomationSystemConfigurationModal, setDisplayEditAutomationSystemConfigurationModal] =
    useState(false);
  const handleCloseAutomationSystemConfigurationModal = () => setDisplayEditAutomationSystemConfigurationModal(false);

  const { data: automationSystem, loadingState: automationSystemLoadingState } = useSelector(getAutomationSystem);
  const { data: automationSystemConfig, loadingState: automationSystemConfigLoadingState } =
    useSelector(getAutomationSystemConfig);

  useEffect(() => {
    dispatch(loadMachineAutomationSystem(machineId));
    dispatch(loadMachineAutomationSystemConfig(machineId));
  }, [dispatch, machineId]);

  return (
    <>
      <AutomationSystemCard
        automationSystem={automationSystem}
        setDisplayEditAutomationSystemModal={setDisplayEditAutomationSystemModal}
        reloadAction={() => {
          dispatch(loadMachineAutomationSystem(machineId));
        }}
        loadingState={automationSystemLoadingState}
        loadingComponent={() => <AutomationSystemCardLoader automationSystem={automationSystem} />}
        errorComponent="Error"
        ignoreError={false}
      />
      <EditAutomationSystemModal
        open={displayEditAutomationSystemModal}
        handleClose={handleCloseAutomationSystemModal}
        machineId={machineId}
        automationSystem={automationSystem}
      />
      <AutomationSystemConfigurationCard
        automationSystem={automationSystem}
        setDisplayEditAutomationSystemConfigurationModal={setDisplayEditAutomationSystemConfigurationModal}
        automationSystemConfig={automationSystemConfig}
        reloadAction={() => {
          dispatch(loadMachineAutomationSystemConfig(machineId));
        }}
        loadingState={automationSystemConfigLoadingState}
        loadingComponent={() => <AutomationSystemConfigurationLoader automationSystem={automationSystem} />}
        errorComponent="Error"
        ignoreError={false}
      />
      {automationSystem.plc_type === PlcType.IRIS_V3 ? (
        <EditAutomationSystemConfigurationIRISV3
          open={displayEditAutomationSystemConfigurationModal}
          handleClose={handleCloseAutomationSystemConfigurationModal}
          machineId={machineId}
          automationSystem={automationSystem}
        />
      ) : automationSystem.plc_type === PlcType.ROCKWELL ? (
        <EditAutomationSystemConfigurationIRISV2Rockwell
          open={displayEditAutomationSystemConfigurationModal}
          handleClose={handleCloseAutomationSystemConfigurationModal}
          machineId={machineId}
          automationSystem={automationSystem}
        />
      ) : automationSystem.plc_type === PlcType.SIEMENS_S7 ? (
        <EditAutomationSystemConfigurationIRISV2Siemens
          open={displayEditAutomationSystemConfigurationModal}
          handleClose={handleCloseAutomationSystemConfigurationModal}
          machineId={machineId}
          automationSystem={automationSystem}
        />
      ) : automationSystem.plc_type === PlcType.IRIS_V3_ESSENTIALS ? (
        <EditAutomationSystemConfigurationIRISV3Essentials
          open={displayEditAutomationSystemConfigurationModal}
          handleClose={handleCloseAutomationSystemConfigurationModal}
          machineId={machineId}
          automationSystem={automationSystem}
        />
      ) : automationSystem.plc_type === PlcType.IRIS_V3_INSIDE_S7 ? (
        <EditAutomationSystemConfigurationIRISV3Inside
          open={displayEditAutomationSystemConfigurationModal}
          handleClose={handleCloseAutomationSystemConfigurationModal}
          machineId={machineId}
          automationSystem={automationSystem}
        />
      ) : automationSystem.plc_type === PlcType.IRIS_V3_INSIDE_ROCKWELL ? (
        <EditAutomationSystemConfigurationIRISV3InsideRockwell
          open={displayEditAutomationSystemConfigurationModal}
          handleClose={handleCloseAutomationSystemConfigurationModal}
          machineId={machineId}
        />
      ) : (
        <></>
      )}

      <Gateway />
    </>
  );
};

export default AutomationSystem;
